import alertWarningSmallTokens from '@amzn/meridian-tokens/base/icon/alert-warning-small';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import React, { FC } from 'react';
import { Text, TranslatedString } from '../../../components/blocks/localization';

export type WarningSentenceProps = {
    text: TranslatedString;
    dataTestId?: string;
};

const WarningSentence: FC<WarningSentenceProps> = ({ text, dataTestId }) => (
    <Row spacing={'xsmall'} alignmentVertical={'top'} data-testid={dataTestId}>
        <Icon tokens={alertWarningSmallTokens} />
        <Text type={'b200'}>{text}</Text>
    </Row>
);

export { WarningSentence };
